// extracted by mini-css-extract-plugin
module.exports = {"container":"agreement_container__3N1h8","checkmark":"agreement_checkmark__3PXXH","error":"agreement_error__18oiu"};